export const scrollMixin = {
    mounted: function () {
        window.scrollTo(0, 0)
    }
}